import { Controller } from "@hotwired/stimulus"

// Updates a target <turbo-frame>'s `src` when the controller's element fires a change event.
// The URL is built by replacing the literal "__VALUE__" placeholder in `urlTemplateValue`
// with the (URL-encoded) value of the changed input. Setting `src` causes Turbo to fetch
// the URL and swap the matching frame from the response.
//
// Usage:
//   <select
//     data-controller="frame-src-updater"
//     data-action="change->frame-src-updater#update"
//     data-frame-src-updater-frame-id-value="some_frame"
//     data-frame-src-updater-url-template-value="/path?param=__VALUE__"
//   >
export default class extends Controller {
  static values = {
    frameId: String,
    urlTemplate: String,
  }

  update(event) {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return
    const value = encodeURIComponent(event.target.value)
    frame.src = this.urlTemplateValue.replace("__VALUE__", value)
  }
}
